import { RegisterModule } from '@/typings/common'
import {
  PublicationsStorageFilesState,
  PublicationsStorageFilesGetters,
  PublicationsStorageFilesMutations,
  PublicationsStorageFilesActions,
} from './store'
import { createMapper, registerModule as vuexRegisterModule, Module } from 'vuex-smart-module'
import { MODULE_NAME } from '../utils'


const storeModule = (
  new Module({
    namespaced: true,
    state: PublicationsStorageFilesState,
    getters: PublicationsStorageFilesGetters,
    mutations: PublicationsStorageFilesMutations,
    actions: PublicationsStorageFilesActions,
  })
)

const mapper = createMapper(storeModule)

export {
  storeModule as publicationStorageFilesStoreModule,
  mapper as publicationStorageFilesStoreMapper,
}

export const registerModule: RegisterModule = ({ store }): void => {
  if (registerModule.installed) return

  vuexRegisterModule(
    store,
    MODULE_NAME,
    MODULE_NAME,
    storeModule,
  )

  registerModule.installed = true
}
